import * as types from './photo_reducer';

export function addPhoto(state, photo) {
    return {
        type: types.PHOTO_STATE_ADD,
        payload: photo,
    };
}

